import React, { useState } from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import classNames from "classnames";
import Tooltip from "@material-ui/core/Tooltip";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import AvatarView from "../Common/AvatarView";
import GuardianAdmin from "../Management/Messaging/icons/GuardianAdmin";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: "100%",
      overflow: "hidden",
      cursor: "auto",
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(1),
      border: "1px solid transparent",
      "&:hover": {
        border: "1px solid #EAEDF0",
        borderRadius: 32,
      },
      "&.selected": {
        border: "1px solid #EAEDF0",
        borderRadius: 32,
        backgroundColor: "#F7F8FD",
      },
      "&.disabled": {
        "&:hover": {
          border: "1px solid transparent",
        },
      },
    },
    peerInfo: {
      fontSize: "1rem",
      border: "none",
      display: "flex",
      paddingLeft: theme.spacing(0.5),
      flexGrow: 1,
      alignItems: "center",
      cursor: "pointer",
    },
    adminBadge: {
      color: "#faa61a",
      fontSize: "1.25rem",
      marginTop: 10,
      marginRight: 6,
    },
    moderatorBadge: {
      color: "#616161",
      fontSize: "1.25rem",
      marginTop: 10,
      marginRight: 6,
    },
    indicators: {
      left: 0,
      top: 0,
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      transition: "opacity 0.3s",
    },
    controls: {
      float: "right",
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
    },
    iconButton: {
      borderRadius: "50%",
      border: "1px solid #eaedf0",
      marginRight: theme.spacing(1),
      backgroundColor: "#ffffff",
      padding: 5,
      color: "#8790A6",
    },
  })
);

const Participant = ({
  participant,
  indicators = [],
  actions = [],
  children,
  disabled = false,
  onClick,
  soundOn = false,
}) => {
  const classes = useStyles();
  const [selected, setSelected] = useState(false);

  const handleClick = (e) => {
    setSelected(true);
    onClick && onClick(e);
  };

  const handleClickAway = () => {
    setSelected(false);
  };

  let badge = "";
  if (
    participant.roles &&
    participant.roles.some((role) => ["admin"].includes(role))
  ) {
    badge = "adminBadge";
  } else if (
    participant.roles &&
    participant.roles.some((role) => ["moderator"].includes(role))
  ) {
    badge = "moderatorBadge";
  }
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div
        className={classNames(classes.root, {
          selected: selected,
          disabled: disabled,
        })}
      >
        <Badge
          badgeContent={
            badge ? <GuardianAdmin className={classes[badge]} /> : ""
          }
        >
          <AvatarView
            alt={participant.displayName}
            id={participant.id}
            style={selected ? { backgroundColor: "white" } : {}}
            displayName={participant.displayName}
            onClick={handleClick}
          />
        </Badge>

        <div className={classes.peerInfo} onClick={handleClick}>
          {participant.displayName}
          {/*{soundOn && <SoundBar id={participant.id} />}*/}
        </div>
        <div className={classes.indicators}>
          {indicators.map((indicator, index) => {
            return (
              <Tooltip title={indicator.label} key={index}>
                <IconButton
                  aria-label={indicator.label}
                  className={classes.iconButton}
                  size="small"
                  {...indicator}
                />
              </Tooltip>
            );
          })}
        </div>
        {children}
        <div className={classes.controls}>
          {actions.map((action, index) => {
            return (
              <Tooltip title={action.label} key={index}>
                <IconButton
                  aria-label={action.label}
                  className={classes.iconButton}
                  size="small"
                  {...action}
                />
              </Tooltip>
            );
          })}
        </div>
      </div>
    </ClickAwayListener>
  );
};

Participant.propTypes = {
  participant: PropTypes.object.isRequired,
  actions: PropTypes.array,
  indicators: PropTypes.array,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  soundOn: PropTypes.bool,
};

export default Participant;
